// ════════════════════════════════════════════════════════════════════════════
// PHIÊN ĐĂNG NHẬP — "VÉ CHẾT THẬT" hay "CHƯA HỎI ĐƯỢC NGƯỜI GÁC VÉ"?
//
// 🩸 VÉ THẬT 14/08/2026 ở /appointments (bản 9a083a6), nổ 1 lần:
//     Error: Hết phiên đăng nhập — thao tác vừa rồi CHƯA được lưu. Hãy tải lại trang,
//            đăng nhập lại rồi làm lại.
//         at M (…/_next/static/chunks/3200-075461d0cf4aef5e.js:1:51724)
//   Khung `M` = `fetchServerAction` của Next (cùng mảnh 3200, cạnh cột 50622 đã giải mã hồi 05/08 —
//   xem lib/loi/khong-toi-may-chu.ts). Cột 51724 rơi vào nhánh NÉM của chính hàm đó:
//       server-action-reducer.js:106 →
//         const message = res.status >= 400 && contentType === 'text/plain' ? await res.text() : …
//         throw new Error(message)
//   ⇒ Câu này KHÔNG do mã nghiệp vụ ném ra: nó là NGUYÊN VĂN body 401 mà cổng gác
//     (lib/supabase/middleware.ts) trả về.
//
// 🕳️ VÌ SAO CỔNG GÁC LẠI NÓI "HẾT PHIÊN" KHI PHIÊN CÓ THỂ VẪN TỐT — đọc mã @supabase/auth-js
//    2.108.2 (bản đang cài), KHÔNG đoán:
//      · `GoTrueClient._getUser()` bọc mọi thứ trong try/catch, và trong catch:
//            if (isAuthError(error)) { …; return { data: { user: null }, error } }   ← TRẢ VỀ
//            throw error                                                             ← chỉ lỗi LẠ mới ném
//        ⇒ MỌI lỗi thuộc họ Auth đi ra bằng **trường `error`**, KHÔNG bằng `throw`.
//      · `lib/fetch.js` biến sự cố ĐƯỜNG TRUYỀN thành lỗi họ Auth luôn:
//            fetch hỏng (mạng/CORS/timeout) → new AuthRetryableFetchError(msg, 0)
//            HTTP 500…530 của GoTrue        → new AuthRetryableFetchError(msg, status)
//        Cả hai đều có `__isAuthError = true`.
//    ⇒ Cổng gác trước đây chỉ đọc `data` và VỨT `error`, rồi suy: "không ném mà user rỗng + còn
//      cookie ⇒ vé chết ⇒ XOÁ cookie phiên". Nên một cú chập mạng Railway↔Supabase, một lượt 5xx
//      hay 429 của máy chủ đăng nhập là ĐĂNG XUẤT OAN người đang làm việc, kèm câu "Hết phiên
//      đăng nhập" — trong khi vé của họ còn nguyên và vài giây sau đã gọi lại được.
//      (Chính ghi chú trong cổng gác đã dặn "lỗi mạng thì KHÔNG xóa cookie" — nhánh ấy chưa bao
//      giờ chạy, vì lỗi mạng không đi đường `throw`.)
//
// LUẬT Ở ĐÂY: **CHỈ ĐĂNG XUẤT KHI CÓ CỚ**. Không kết luận được thì giữ vé lại — thiệt hại của
// giữ nhầm là một lượt bấm lại; thiệt hại của xoá nhầm là bắt cả phòng khám đăng nhập lại giữa ca.
//
// THUẦN: không React, không DOM, không Next → chạy được cả ở cổng gác (Edge), server lẫn trình
// duyệt, và test rà thẳng được (test/phien-hut-oan-vi-may-chu-auth.test.ts).
// ════════════════════════════════════════════════════════════════════════════

/**
 * Câu Next hiện NGUYÊN VĂN khi server action bị chặn vì VÉ ĐÃ CHẾT THẬT (hết hạn, không làm mới
 * được, phiên đã bị thu hồi). Người dùng BẮT BUỘC phải đăng nhập lại.
 * ⚠️ Cổng gác trả câu này làm BODY của 401 (content-type đúng chuỗi "text/plain") — đổi câu ở đây
 * là đổi luôn câu người dùng đọc; đừng chép tay bản thứ hai ở nơi khác.
 */
export const CAU_HET_PHIEN =
  "Hết phiên đăng nhập — thao tác vừa rồi CHƯA được lưu. Hãy tải lại trang, đăng nhập lại rồi làm lại.";

/**
 * Câu cho ca CHƯA HỎI ĐƯỢC máy chủ đăng nhập (mạng chập, Supabase Auth 5xx/timeout/quá nhịp).
 * Khác câu trên ở đúng chỗ QUAN TRỌNG NHẤT với người đang làm việc: **không phải đăng nhập lại**,
 * chỉ chờ vài giây rồi bấm lại. Nói nhầm thành "hết phiên" là đẩy họ đi gõ lại mật khẩu vô ích.
 */
export const CAU_MAY_CHU_AUTH_BAN =
  "Máy chủ đăng nhập chưa trả lời — thao tác vừa rồi CHƯA được lưu. Chờ vài giây rồi bấm lại; bạn KHÔNG cần đăng nhập lại.";

/**
 * Mã HTTP mà máy chủ đăng nhập trả về nhưng KHÔNG chứng minh được vé đã chết:
 *   0   — `AuthRetryableFetchError` khi cú fetch không đi tới nơi (mạng/CORS/timeout)
 *   408 — hết giờ chờ
 *   429 — quá nhịp (rate limit) — vé vẫn tốt, chỉ là hỏi dồn quá
 * (≥ 500 xử riêng bên dưới: cả họ 5xx đều là "máy chủ đang hỏng", không phải "vé của bạn hỏng".)
 */
const MA_CHUA_KET_LUAN_DUOC = new Set([0, 408, 429]);

/** Lỗi thuộc họ Auth của Supabase? Gói tự gắn cờ `__isAuthError` trên mọi lớp lỗi của nó. */
export function laLoiAuth(e: unknown): boolean {
  return (
    !!e &&
    typeof e === "object" &&
    "__isAuthError" in e &&
    (e as { __isAuthError?: boolean }).__isAuthError === true
  );
}

/**
 * Lỗi này CHƯA ĐỦ CỚ để kết luận "vé chết" ⇒ TUYỆT ĐỐI không xoá cookie phiên.
 *
 * Nhận `true` khi:
 *   ① lỗi KHÔNG thuộc họ Auth — hụt khoá, lỗi lạ của môi trường… đều không nói gì về vé;
 *   ② `AuthRetryableFetchError` — chính gói tự khai "thử lại được" (mạng hỏng hoặc GoTrue 5xx);
 *   ③ mã 0 · 408 · 429 · ≥ 500 — máy chủ đang hỏng/bận, không phải vé hỏng.
 *
 * Nhận `false` (⇒ vé chết thật, cứ dọn cookie) với 400/401/403/422…: "Invalid Refresh Token",
 * "Auth session missing", JWT hết hạn — đây mới là những câu nói RÕ vé không dùng được nữa.
 */
export function chuaDuCoDeDangXuat(e: unknown): boolean {
  if (e == null) return false; // không có lỗi thì không rơi vào diện này
  if (!laLoiAuth(e)) return true; // ①
  if ((e as { name?: unknown }).name === "AuthRetryableFetchError") return true; // ②
  const ma = (e as { status?: unknown }).status;
  if (typeof ma !== "number") return true; // lỗi họ Auth mà không khai mã → không đủ cớ
  return MA_CHUA_KET_LUAN_DUOC.has(ma) || ma >= 500; // ③
}

/**
 * Hai ca cổng gác chặn — PHẢI phân biệt được, vì LỐI RA ngược nhau:
 *   · "het-phien"        → vé chết thật ⇒ phải ĐĂNG NHẬP LẠI (đưa thẳng về /login);
 *   · "may-chu-auth-ban" → vé còn nằm trong máy họ ⇒ chỉ CHỜ VÀI GIÂY RỒI BẤM LẠI.
 * Bày nhầm lối là hoặc bắt người ta gõ lại mật khẩu vô ích, hoặc bảo họ "thử lại" mãi một cú bấm
 * không bao giờ chạy được.
 */
export type LoaiCongGac = "het-phien" | "may-chu-auth-ban";

/**
 * Câu này do CỔNG GÁC gửi xuống (qua body 401/503 của server action) không — và là ca NÀO?
 * So khớp NGUYÊN VĂN với 2 câu ở trên — cố ý KHÔNG dò theo từ khoá ("phiên", "đăng nhập"): dò
 * lỏng là bắt oan câu nghiệp vụ của mình (vd "Ca này chưa mở phiên làm việc") rồi hiện sai chỗ.
 */
export function phanLoaiCongGac(e: unknown): LoaiCongGac | null {
  const cau = e instanceof Error ? e.message : typeof e === "string" ? e : "";
  const goi = cau.trim();
  if (goi === CAU_HET_PHIEN) return "het-phien";
  if (goi === CAU_MAY_CHU_AUTH_BAN) return "may-chu-auth-ban";
  return null;
}

/** Đây có phải câu do CỔNG GÁC gửi xuống không? (chỉ cần biết CÓ/KHÔNG — xem `phanLoaiCongGac`) */
export function laCauCuaCongGac(e: unknown): boolean {
  return phanLoaiCongGac(e) !== null;
}

/**
 * Tiêu đề màn lỗi cho từng ca. MỘT nguồn duy nhất cho CẢ HAI lưới hứng lỗi (app/error.tsx và
 * app/global-error.tsx) — hai lưới nói hai giọng khác nhau về cùng một sự cố là người dùng tưởng
 * hai bệnh khác nhau.
 */
export const TIEU_DE_CONG_GAC: Record<LoaiCongGac, string> = {
  "het-phien": "Hết phiên đăng nhập",
  "may-chu-auth-ban": "Máy chủ đăng nhập chưa trả lời",
};

/**
 * Lỗi này có ĐÁNG đẻ một vé về hộp lỗi SugaHub không?
 *
 * 🩸 VÉ THẬT 02/09/2026 ở `/` (bản 83e6de4), nguồn `global-error`, nổ 1 lần: nguyên văn
 * `CAU_HET_PHIEN`, vết lỗi đúng MỘT khung rút gọn (`at I (…/chunks/1fey5….js:2:743)` =
 * `fetchServerAction` của Next). Vé ấy KHÔNG có gì để lần: không mã sự cố, không khung mã của
 * mình, còn câu chữ thì do CHÍNH cổng gác của ta viết ra. Nó chỉ nói lại một sự thật bình thường
 * — **một phiên đăng nhập đã hết hạn** — nhưng vào hộp lỗi thì thành phiếu 🟠 "chức năng", và
 * tốn trọn một vòng người/máy đi truy một thứ không có gì để vá.
 *
 * ⇒ "het-phien" (401): KHÔNG đẻ vé. Đây là việc xảy ra với mọi người dùng, mọi ngày.
 * ⇒ "may-chu-auth-ban" (503): VẪN đẻ vé — ca này là BẤT THƯỜNG (Supabase Auth 5xx/timeout/429,
 *   mạng Railway↔Supabase chập), và chính họ lỗi này đã che vụ ĐĂNG XUẤT OAN 14/08 suốt một thời
 *   gian. Bịt luôn nó là tự chọc mù mình đúng chỗ từng chảy máu.
 *
 * KHÔNG mất dấu ca "het-phien": cổng gác vẫn `console.warn` kèm tên + mã lỗi ở log máy chủ
 * (lib/supabase/middleware.ts) — chỗ đó biết RÕ vì sao vé chết, hơn hẳn cái vé trình duyệt này.
 */
export function nenDeVeLoi(e: unknown): boolean {
  return phanLoaiCongGac(e) !== "het-phien";
}

/**
 * Câu NÊN HIỆN cho người dùng khi một lời gọi server action hỏng.
 *
 * Cổng gác chặn (hết phiên / máy chủ đăng nhập bận) thì câu của nó đã viết sẵn cho người đọc —
 * phải để nguyên. Còn lại thì dùng câu dự phòng của chỗ gọi, vì câu lỗi ném từ server action đã bị
 * Next che sạch ở bản thật (xem lib/action-result.ts) nên bê ra chỉ tổ khó hiểu.
 *
 * VÌ SAO CẦN: chỗ gọi nào nuốt `e` rồi hiện câu dự phòng kiểu "kiểm tra lại thông tin rồi thử lại"
 * sẽ ĐỔ OAN cho dữ liệu người ta vừa nhập, trong khi thủ phạm là cái vé — họ sửa tới sửa lui mà
 * bấm lần nào cũng hỏng.
 */
export function cauChoNguoiDung(e: unknown, duPhong: string): string {
  return laCauCuaCongGac(e) ? (e as Error).message.trim() : duPhong;
}
